import { ExternalConfigSpecialCourse } from '@web/store/types/modules/assets'
import anyConst from './anySpecialHome'
import takeConst from './takeSpecialHome'

const emptyDefaultConstants = {
  defaultCourseIds: [],
  defaultRecommendedCourseIds: [],
  defaultNewCourseIds: [],
  defaultTopSaleCourseIds: [],
  defaultSpecialCourseId: {} as Record<number, ExternalConfigSpecialCourse>,
  defaultSpecialCourseIdsInSubscription: {} as Record<number, number>,
  defaultSpecialCourseIdsBundle: [],
  defaultSpecialCourseIdForClub: 0,
  defaultSpecialClubId: 0,
  defaultPaywallServiceId: 0,
  defaultLinkQuiz: '',
  defaultLinkBundle: '',
  defaultLinkClub: ''
}

export function getSpecialHomeConst (project: 'any' | 'take') {
  if (project === 'take') {
    return takeConst
  }
  if (project === 'any') {
    return anyConst
  }

  return emptyDefaultConstants
}
